var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-za",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M70.1 0h499.6v499.6H70.1z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-71.9) scale(1.0248)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 397.9v-296l220.4 147.9L0 397.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00c",
    d: "m150.4 499.7 247.4-166.5h351.6v166.5h-599z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M134.5 0h615v166.6H397.7S137.8-1.6 134.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc0",
    d: "M0 62.5v39.3l220.4 148L0 397.8v39.4l277.6-187.4L0 62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#093",
    d: "M0 62.5V0h92.6l294 199h362.8v101.7H386.6l-294 198.9H0v-62.4l277.6-187.4L0 62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M92.6 0h57.8l247.4 166.6h351.6V199H386.6L92.6 0zm0 499.7h57.8l247.4-166.5h351.6v-32.4H386.6l-294 198.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZa);
export default __webpack_public_path__ + "static/media/za.5d3c78bdb1ecad89b5f8068a8eb12a2b.svg";
export { ForwardRef as ReactComponent };